import { Pagination } from "../../ui-kit";
import React from "react";

export interface IStoredPagination {
  page: number;
  total: number;
  pages: number;
  perPage: number;
  onPageChange: (page) => void;
  onPerPageChange: (value) => void;
  showPerPageChoices?: boolean;
}

// Небольшая прослойка для подключения пагинации, хранящейся в сторе
export const StoredPagination: React.FC<IStoredPagination> = ({
  page = 1,
  onPageChange,
  perPage,
  onPerPageChange,
  total,
  pages,
  showPerPageChoices = true,
}) => {
  return (
    <Pagination
      onChange={onPageChange}
      initialPage={page - 1}
      pageCount={pages}
      totalItemsCount={total}
      onPerPageChange={onPerPageChange}
      perPageValue={perPage}
      showPerPageChoices={showPerPageChoices}
    />
  );
};
